import { PersonCards } from "../../global/person-card";
import { Title } from "../../global/title/title";

//assets
import Avatar from "../../../assets/images/avatar.png";

export const Team = () => {
  return (
    <div className="team section">
      <div className="container">
        <Title black="Our Team" blue="Work" />
        <div className="mt--large"> </div>
        <PersonCards list={list} />
        <div className="mt--large"> </div>
        <PersonCards list={list2} />
      </div>
    </div>
  );
};
const list = [
  {
    id: "1",
    img: Avatar,
    name: "Ziad Ehab",
    desc: "Specialization",
  },
  {
    id: "2",
    img: Avatar,
    name: "Ziad Elnory",
    desc: "Specialization",
  },
  {
    id: "3",
    img: Avatar,
    name: "Ziad Elnory",
    desc: "Specialization",
  },
];
const list2 = [
  {
    id: "1",
    img: Avatar,
    name: "Radwa Mahmoud",
    desc: "Specialization",
  },
  {
    id: "2",
    img: Avatar,
    name: "Shrouk Raffat",
    desc: "Specialization",
  },
];
